module.exports = __webpack_public_path__ + "static/media/nx.ae12ea22.hdr";